/** PostgREST's "no such column" answers — a column a not-yet-applied
 *  migration adds. PGRST204 = "Could not find the … column … in the schema
 *  cache" (writes), 42703 = undefined_column (selects). Shared by every
 *  repository that reads or writes an optional column. */
export function isMissingColumn(e: unknown): boolean {
  const o = (e ?? {}) as { code?: unknown; message?: unknown };
  if (o.code === '42703' || o.code === 'PGRST204') return true;
  return typeof o.message === 'string' && /column .* does not exist|could not find the .* column/i.test(o.message);
}
